import React from "react";
import { Box } from "@mui/material";
import { darkColors } from "../../../theme/colors";

const Popup = ({
  open,
  onClose,
  children,
  containerStyle = {},
  contentStyle = {},
}) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.8)", // Black overlay with opacity
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1, // High z-index to ensure it appears above other elements
        ...containerStyle, // Allow overriding container styles
      }}
      onClick={onClose} // Close popup on overlay click
    >
      <Box
        sx={{
          background: darkColors.background,
          padding: "2rem",
          borderRadius: "8px",
          maxWidth: "420px",
          width: "90%",
          boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.3)",
          ...contentStyle, // Allow overriding content styles
        }}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the popup
      >
        {children}
      </Box>
    </Box>
  );
};

export default Popup;
